export const invoiceList = {
  head: {
    title: "Facturation",
    subtitle: "Factures émises à vos clients",
  },
  stats: {
    filterAria: "Filtrer les factures par statut",
    total: "Total",
    draft: "Brouillons",
    sent: "Émises",
    processing: "En traitement",
    error: "En erreur",
    pending: "En attente",
    voided: "Annulées",
  },
  toolbar: {
    searchLabel: "Rechercher des factures",
    searchPlaceholder: "N° de facture, client, e-mail, numéro fiscal ou réservation…",
    clearSearch: "Effacer la recherche",
    propertyLabel: "Logement",
    allProperties: "Tous les logements",
    typeToSearchProperties: "Saisissez pour rechercher des logements.",
    noProperties: "Aucun logement trouvé.",
    statusLabel: "Statut",
    emisorLabel: "Émetteur",
    allEmisores: "Tous les émetteurs",
    servicesTitle: "Catalogue de frais et services réutilisables",
    services: "Frais et services",
    createInvoice: "Créer une facture",
  },
  exportZip: {
    button: "ZIP",
    title: "Un fichier par facture, chacune avec sa date et son code de réservation, le tout dans un ZIP",
    generating: "Génération…",
    zipping: "Compression…",
    noPdfInPeriod: "Aucune facture émise avec PDF sur la période.",
    noPdfInPage: "Aucune facture émise avec PDF sur cette page.",
    tooMany: "La sélection contient {total} factures et le ZIP en accepte {limit}. Restreignez la période ou les filtres.",
    noneDownloaded: "Aucune facture n'a pu être téléchargée depuis Invopop. Réessayez dans quelques minutes.",
    failed: "{n} facture(s) n'ont pas pu être téléchargées depuis Invopop : {codes}.",
    withoutPdf: "{n} facture(s) n'ont pas encore de PDF dans Invopop et ne figurent pas dans le ZIP : {codes}.",
    restIncluded: "Toutes les autres sont bien dans le ZIP.",
    error: "Impossible de générer le ZIP des factures.",
  },
  linkedClient: {
    prefix: "Factures liées à",
    fallbackName: "ce client de facturation",
    clear: "Retirer le filtre client",
  },
  table: {
    numberHeader: "N° DE FACTURE",
    customerHeader: "CLIENT",
    propertyHeader: "LOGEMENT",
    totalHeader: "TOTAL",
    statusHeader: "STATUT",
    dateHeader: "DATE",
    actionsHeader: "ACTIONS",
    draftReferenceTitle: "Référence de brouillon. Le numéro fiscal est attribué lors de l'émission.",
    openReserva: "Ouvrir la réservation",
    viewCreditNote: "Voir la facture rectificative {code}",
    creditNote: "Facture rectificative",
    viewError: "Voir l'erreur",
    voids: "Annule",
    correctionOf: "Corr. de",
    correctedBy: "Corrigée par :",
  },
  sortFields: {
    number: "numéro de facture",
    customer: "client",
    property: "logement",
    total: "total",
    status: "statut",
    date: "date",
  },
  sort: {
    sortBy: "Trier par {label}",
    sortedBy: "Trié par {label}, {direction}. Modifier l'ordre",
    asc: "croissant",
    desc: "décroissant",
  },
  actions: {
    openPdf: "Ouvrir la facture en PDF",
    editDraftTitle: "Modifier les informations du client et les lignes",
    edit: "Modifier",
    previewTitle: "Ouvrir un aperçu sans valeur fiscale",
    preview: "Aperçu",
    sendQuote: "Devis",
    sendQuoteTitle: "Envoyer le devis au client par e-mail",
    emitTitle: "Vérifier et émettre la facture",
    emit: "Émettre",
    syncTitle: "Actualiser le statut de la facture",
    sync: "Actualiser",
    retryTitle: "Réessayer avec des informations de facturation à jour",
    retry: "Réessayer",
    moreOptions: "Plus d'options",
    moreOptionsAria: "Plus d'options de facture",
    editCustomer: "Modifier les informations du client",
    deleteReset: "Supprimer et réinitialiser la demande",
    voidReissue: "Annuler et réémettre",
  },
  empty: {
    searchTitle: "Aucune facture trouvée",
    searchText: "Aucun résultat ne correspond à la recherche et aux filtres actuels.",
    clearFilters: "Effacer les filtres",
    title: "Aucune facture pour le moment",
    text: "Créez un brouillon et émettez-le une fois les informations fiscales et les frais prêts.",
    createFirst: "Créez votre première facture",
  },
  errorModal: {
    title: "Erreur de facture",
    hintBefore: "Si l'erreur concerne vos informations de facturation (numéro fiscal, série…), corrigez-les dans",
    hintSettingsPath: "Paramètres → Facturation",
    hintBetween: "puis utilisez",
    hintRetryWord: "Réessayer",
    hintGuest: "Si l'erreur concerne les informations du client, utilisez",
    hintEditWord: "Modifier les informations du client",
    close: "Fermer",
    retryNow: "Réessayer maintenant",
  },
  editCustomer: {
    title: "Modifier les informations du client",
    subtitle: "Corrigez les informations et réessayez la facture",
    name: "Nom / Raison sociale *",
    taxId: "Numéro fiscal / numéro VAT",
    country: "Pays (code à 2 lettres) *",
    email: "E-mail *",
    address: "Adresse",
    city: "Ville",
    zip: "Code postal",
    hint: "Lors de l'enregistrement, l'envoi de la facture sera automatiquement réessayé.",
    cancel: "Annuler",
    saving: "Enregistrement…",
    save: "Enregistrer et réessayer",
  },
  deleteConfirm: {
    title: "Supprimer la facture",
    body1: "Cette tentative de facture sera supprimée et la",
    bodyStrong: "demande du client sera réinitialisée",
    body2: ", ce qui lui permettra de saisir à nouveau ses informations et de redemander la facture.",
    irreversible: "Cette action est irréversible.",
    cancel: "Annuler",
    deleting: "Suppression…",
    confirm: "Oui, supprimer",
  },
  create: {
    titleEdit: "Modifier le brouillon",
    titleCreate: "Créer une facture",
    subtitleEdit: "Mettez à jour le client, le contexte et les lignes. La facture n'est pas émise.",
    subtitleCreate: "Brouillon — aucun numéro tant qu'elle n'est pas émise. Aucune réservation requise.",
    loading: "Chargement du brouillon…",
    clientLabel: "Client *",
    clientHelp: "Sélectionnez un profil de facturation enregistré ou créez-en un nouveau.",
    newClient: "Nouveau client",
    company: "Entreprise",
    individual: "Particulier",
    change: "Changer",
    clientSearchPlaceholder: "Rechercher par nom, e-mail ou document…",
    incomplete: "Incomplet",
    noClients: "Aucun client trouvé.",
    createClient: "Créer un client",
    contextTitle: "Contexte de la facture",
    optional: "Facultatif",
    contextHelp: "Liez cette facture pour conserver sa traçabilité. Vous pouvez laisser les deux champs vides.",
    propertyLabel: "Logement",
    propertyPlaceholder: "Rechercher un logement…",
    typeToSearchProperties: "Saisissez pour rechercher des logements.",
    noProperties: "Aucun logement trouvé.",
    reservationLabel: "Réservation",
    reservationPlaceholder: "Rechercher un code, un client, un e-mail…",
    noHolder: "Aucun titulaire",
    typeToSearchReservations: "Saisissez pour rechercher des réservations.",
    noReservations: "Aucune réservation trouvée.",
    contextNotice: "La réservation définit le logement et ajoute le séjour s'il n'a pas encore été facturé.",
    chargesTitle: "Frais et services",
    chargesHelp: "Sélectionnez des éléments enregistrés dans votre catalogue.",
    addCharge: "Ajouter un frais ou un service",
    colConcept: "Élément",
    colQty: "Qté",
    colUnitPrice: "Prix unitaire",
    colTotal: "Total",
    docTitle: "Aperçu de la facture",
    docHint: "Voici les lignes que portera le PDF. L'hébergement, les remises et les frais automatiques viennent de la réservation : ci-dessus vous ne modifiez que les frais de votre catalogue.",
    due: "Reste à payer",
    assumed: "Aucun paiement n'est enregistré sur cette réservation. Le montant est considéré comme encaissé d'après le mode de paiement indiqué, et le PDF l'indiquera de même.",
    linesEmpty: "Ajoutez un ou plusieurs éléments depuis votre catalogue.",
    total: "Total",
    cancel: "Annuler",
    saving: "Enregistrement…",
    saveChanges: "Enregistrer les modifications",
    saveDraft: "Enregistrer le brouillon",
  },
  contextSummary: {
    property: "Logement sélectionné",
    empty: "Ajoutez un logement ou une réservation",
  },
  emit: {
    title: "Émettre la facture",
    subtitle: "Cette action attribuera le numéro fiscal définitif.",
    client: "Client",
    property: "Logement",
    total: "Total",
    warning: "Une fois émise, vous ne pourrez plus la modifier directement ; toute correction nécessitera un document rectificatif.",
    cancel: "Annuler",
    emitting: "Émission…",
    confirm: "Émettre la facture",
  },
  editDraft: {
    title: "Modifier le brouillon",
    subtitle: "Modifiez les informations du client et les lignes. La facture n'est pas émise.",
    loading: "Chargement du brouillon…",
    individual: "Particulier",
    individualSub: "Personne physique",
    company: "Entreprise",
    companySub: "Personne morale",
    legalName: "Raison sociale *",
    fullName: "Nom complet *",
    companyNamePlaceholder: "Nom de l'entreprise",
    individualNamePlaceholder: "Prénom et nom",
    country: "Pays *",
    docCompany: "Numéro fiscal de l'entreprise (VAT)",
    docIndividual: "Pièce d'identité / Passeport",
    docCompanyPlaceholder: "VAT / Numéro fiscal",
    docIndividualPlaceholder: "Carte d'identité nationale ou passeport",
    email: "E-mail",
    emailOptional: "(facultatif)",
    lodgingTitle: "Logement",
    lodgingName: "Logement",
    lodgingNoteBefore: "Provient de la réservation",
    lodgingNoteAfter: ". Pour modifier ce montant, modifiez-le dans la réservation.",
    chargesTitle: "Frais et services",
    chargesHelp: "Ajoutez des éléments enregistrés sans modifier le logement.",
    addCharge: "Ajouter un frais ou un service",
    colConcept: "Élément",
    colQty: "Qté",
    colUnitPrice: "Prix unitaire",
    colTotal: "Total",
    linesEmpty: "Aucun élément supplémentaire.",
    linesEmptyReserva: "La facture ne comprend que le logement.",
    total: "Total",
    cancel: "Annuler",
    saving: "Enregistrement…",
    saveChanges: "Enregistrer les modifications",
  },
  void: {
    doneTitle: "Facture annulée",
    doneSubtitle: "Facture rectificative émise avec succès",
    whatHappened: "Que s'est-il passé ?",
    doneCreditNote: "La facture rectificative a été émise",
    doneListed: "La facture reste dans la liste, marquée comme annulée",
    doneCharges: "Les frais supplémentaires ont été libérés",
    doneGuest: "Le client peut redemander sa facture",
    nextStepsLabel: "Étapes suivantes :",
    nextStepsText: "Vous pouvez ajouter ou corriger des frais sur la réservation. Renvoyez ensuite le lien de facturation au client.",
    understood: "Compris",
    title: "Annuler et réémettre la facture",
    introBefore: "Cette action",
    introStrong: "annulera la facture émise",
    introAfter: "au moyen d'une facture rectificative officiel.",
    willEmit: "Une facture rectificative sera émis",
    willList: "La facture restera dans la liste, marquée comme annulée",
    willFree: "Les frais supplémentaires seront libérés",
    willAllowGuest: "Le client pourra redemander la facture",
    reasonLabel: "Motif de l'annulation",
    reasonOther: "Autre motif…",
    reasonPlaceholder: "Expliquez pourquoi vous annulez cette facture",
    warning: "La facture rectificative est un document fiscal officiel. Ne l'utilisez que si vous devez réellement corriger la facture.",
    cancel: "Annuler",
    emitting: "Émission de la facture rectificative…",
    confirm: "Oui, annuler et réémettre",
  },
  statusFilters: {
    all: "Toutes",
    draft: "Brouillons",
    sent: "Émises",
    processing: "En traitement",
    error: "En erreur",
    pending: "En attente",
    voided: "Annulées",
  },
  voidReasons: {
    wrongTaxData: "Informations fiscales du client incorrectes",
    wrongAmount: "Montant ou frais incorrects",
    duplicate: "Facture en double",
    cancelledReservation: "Réservation annulée",
    reissue: "Annulée pour réémission avec des informations ou des frais corrigés",
  },
  statusLabels: {
    draft: "Brouillon",
    sent: "Émise",
    processing: "En traitement",
    error: "Erreur",
    pending: "En attente",
    corrected: "Corrigée",
    voided: "Annulée",
  },
  client: {
    fallbackName: "Client",
    fiscalPending: "Profil de facturation en attente",
    fiscalSaved: "Profil de facturation enregistré",
  },
  reservation: {
    noCode: "Sans code",
    noDates: "Sans dates",
    noHolder: "Sans titulaire",
    propertyFallback: "Logement n° {id}",
  },
  emisorFallback: "Émetteur n° {id}",
  toasts: {
    selectClientComplete: "Sélectionnez un client avec un profil de facturation complet.",
    selectReservationOrCharge: "Sélectionnez une réservation ou ajoutez au moins un frais ou service.",
    saveDraftError: "Le brouillon n'a pas pu être enregistré.",
    createError: "La facture n'a pas pu être créée.",
    quoteSent: "Devis envoyé à {email}",
    quoteError: "Le devis n'a pas pu être envoyé.",
    previewError: "L'aperçu n'a pas pu être généré.",
    previewName: "Aperçu",
    emitRejected: "La plateforme fiscale a rejeté l'émission.",
    emitError: "La facture n'a pas pu être émise. Vérifiez les informations fiscales et réessayez.",
    selectClientToContinue: "Sélectionnez un client avec un profil de facturation pour continuer.",
    loadDraftError: "Les détails du brouillon n'ont pas pu être chargés.",
    nameRequired: "Saisissez le nom du client.",
    countryRequired: "Sélectionnez le pays du client.",
    selectCatalogCharge: "Sélectionnez au moins un frais ou service dans le catalogue.",
    retryError: "La nouvelle tentative a échoué.",
    saveError: "Impossible d'enregistrer.",
    voidError: "La facture n'a pas pu être annulée.",
    deleteError: "Impossible de supprimer.",
  },
};
